import { Collection, List } from '@/models'

const setCollectionCountByKind = (kindId) => {
  return (state, count) => {
    state.kindCount[kindId].countCollection = count
  }
}

const setWorkCountByKind = (kindId) => {
  return (state, count) => {
    state.kindCount[kindId].countWork = count
  }
}

export const libraryCount = {
  state() {
    return {
      kindCount: {
        1: {
          countCollection: 0,
          countWork: 0
        }, // 选集
        2: {
          countCollection: 0,
          countWork: 0
        }, // 主题
        7: {
          countCollection: 0,
          countWork: 0
        }, // 词牌
        3: {
          countCollection: 0,
          countWork: 0
        }, // 写景
        4: {
          countCollection: 0,
          countWork: 0
        }, // 节日
        5: {
          countCollection: 0,
          countWork: 0
        }, // 节气
        8: {
          countCollection: 0,
          countWork: 0
        }, // 时令
        6: {
          countCollection: 0,
          countWork: 0
        },  // 课本
        9: {
          countCollection: 0,
          countWork: 0
        },  // 用典
      },

      // collection下的 Count
      collectionWorkCount: {
        // [collectionId]: count
      },
      collectionKindWorkCount: {
        // [collectionKindId]: count
      },

      "listCount": 0,
      "selectedListCount": 0
    }
  },

  actions: {
    loadWorkCountByKind({ commit }, kindId) {

      return Collection.getWorkCountByKindId(kindId).then(result => {
        commit('setWorkCountByKind', { kindId, count: result })

        return result
      })
    },

    loadWorkCountByCollection({ commit }, collectionId) {
      return Collection.getWorkCountByCollection(collectionId).then((result) => {
        commit('setCollectionWorkCount', {
          count: result,
          collectionId
        })

        return result
      })
    },

    loadWorkCountByKindList({ commit }, kindList) {
      return Collection.getWorkCountByKindList(kindList).then(result => {
        result.forEach(item => {
          commit('setCollectionKindWorkCount', { count: item.count, collectionKindId: item.kindId })
        })
        commit('setCountWorkByKindList', result)
        return result
      })
    },

    loadCollectionCountByKindList({ commit }, kindList) {
      return Collection.getCollectionCountByKindList(kindList).then(result => {
        commit('setCountCollectionByKindList', result)

        return result
      })
    },

    loadListCount({ commit }) {
      return List.CountAll().then(result => {
        commit('setListCount', result)

        return result
      })
    },

    loadSelectedListCount({ commit }) {
      return List.CountSelected().then(result => {
        commit('setSelectedListCount', result)

        return result
      })
    }
  },

  mutations: {
    // 设置选集Count
    setSelectCollectionCountByKind: setCollectionCountByKind(1),
    setSelectWorkCountByKind: setWorkCountByKind(1),
    setWorkCountByKind(state, { count, kindId }) {
      state.kindCount[kindId].countWork = count
    },
    setCollectionWorkCount(state, { count, collectionId }) {
      state.collectionWorkCount[collectionId] = count
    },
    setCollectionKindWorkCount(state, { count, collectionKindId }) {
      state.collectionKindWorkCount[collectionKindId] = count
    },

    setCountWorkByKindList(state, countKindList) {
      countKindList.forEach(mem => {
        state.kindCount[mem.kindId].countWork = mem.count
      })
    },

    setCountCollectionByKindList(state, countKindList) {
      countKindList.forEach(mem => {
        state.kindCount[mem.kindId].countCollection = mem.count
      })
    },

    setListCount(state, listCount) {
      state.listCount = listCount
    },

    setSelectedListCount(state, listCount) {
      state.selectedListCount = listCount
    }
  },

  getters: {
    collectionKindWorkCount: (state) => state.collectionKindWorkCount,
    kindCount: state => {
      return {
        classic: state.kindCount[1],
        topic: state.kindCount[2],
        tune: state.kindCount[7],
        nature: state.kindCount[3],
        festival: state.kindCount[4],
        term: state.kindCount[5],
        season: state.kindCount[8],
        book: state.kindCount[6],
        quotation: state.kindCount[9]
      }
    },
    listCount: state => state.listCount,
    selectedListCount: state => state.selectedListCount
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/library-count/index.js